export const CHANGE_ACTIVE_KEY_ADMIN = 'CHANGE_ACTIVE_KEY_ADMIN';

export function changeActiveKeyAdmin(activeKey) {
  return {
    type: CHANGE_ACTIVE_KEY_ADMIN,
    activeKey,
  };
}
